var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShortCompass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 24,
    viewBox: "0 0 72 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66504 12H16.005",
    stroke: "#131C7A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0049 12C26.0049 6.48 30.4749 2 36.0049 2C41.5249 2 46.0049 6.48 46.0049 12C46.0049 17.53 41.5249 22 36.0049 22C30.4749 22 26.0049 17.53 26.0049 12ZM38.2349 13.83L39.8549 8.71C39.9649 8.36 39.6449 8.03 39.2949 8.14L34.1749 9.74C33.9649 9.81 33.7949 9.97 33.7349 10.18L32.1349 15.31C32.0249 15.65 32.3549 15.98 32.6949 15.87L37.7949 14.27C38.0049 14.21 38.1749 14.04 38.2349 13.83Z",
    fill: "#131C7A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0049 12H70.3349",
    stroke: "#131C7A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortCompass);
export default __webpack_public_path__ + "static/media/short-compass.af32aade19570aee0b03c2b64cfb0f8e.svg";
export { ForwardRef as ReactComponent };